module.exports = __webpack_public_path__ + "static/media/piedmonthealthcare.178dc1d1.png";